/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} UnknownInputs */



/**
* | output |
* | --- |
* | "Unknown" |
*
* @param {UnknownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const unknown = /** @type {((inputs?: UnknownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<UnknownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inconnu")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unbekannt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sconosciuto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Неизвестный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desconocido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未知")
	if (locale === "ja") return /** @type {LocalizedString} */ ("未知")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अज्ञात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desconhecido")
	return /** @type {LocalizedString} */ ("Unknown")
});